import React from 'react';
import SearchableSelect from '../Form/SearchableSelect';

/**
 * FilterBar Component - Unified search and filter UI
 * 
 * @param {string} searchTerm - Current search term
 * @param {function} onSearchChange - Search change handler
 * @param {string} searchPlaceholder - Search input placeholder
 * @param {array} filters - Array of filter configs: [{ name, label, value, onChange, options, type }]
 * @param {string} className - Additional CSS classes
 */
const FilterBar = ({
  searchTerm,
  onSearchChange,
  searchPlaceholder = 'Search...',
  filters = [],
  className = ''
}) => {
  return (
    <div className={`mb-6 p-4 theme-card rounded-lg ${className}`}>
      <div className={`grid grid-cols-1 ${filters.length > 0 ? 'md:grid-cols-' + (filters.length + 1) : 'md:grid-cols-1'} gap-4`}>
        {/* Search Input */}
        <div>
          <label className="block text-sm font-medium theme-text-secondary mb-1">Search</label>
          <input
            type="text"
            placeholder={searchPlaceholder}
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            className="w-full px-3 py-2 border rounded-lg theme-input"
          />
        </div>

        {/* Filter Dropdowns */}
        {filters.map((filter, index) => (
          <div key={filter.name || index}>
            <label className="block text-sm font-medium theme-text-secondary mb-1">
              {filter.label}
            </label>
            {filter.type === 'select' ? (
              <SearchableSelect
                name={filter.name}
                value={filter.value || 'all'}
                onChange={(e) => {
                  const newValue = e.target.value || 'all';
                  filter.onChange(newValue);
                }}
                className="w-full"
                placeholder="Select…"
                options={filter.options || []}
                required
              />
            ) : filter.type === 'checkbox' ? (
              <div className="flex items-center">
                <input
                  type="checkbox"
                  id={filter.name}
                  checked={filter.value || false}
                  onChange={(e) => filter.onChange(e.target.checked)}
                  className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                />
                <label htmlFor={filter.name} className="ml-2 text-sm text-gray-700 dark:text-gray-300">
                  {filter.checkboxLabel}
                </label>
              </div>
            ) : null}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FilterBar;

